
import { MessageSquare, History } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ScrollArea } from '@/components/ui/scroll-area';
import { CommentsPanel } from '../CommentsPanel';
import { DocumentStatusHistory } from '../DocumentStatusHistory';
import { DocumentPreview } from './DocumentPreview';

interface DocumentTabsProps {
  documentId: string;
  title: string;
  isLoadingPreview: boolean;
  documentUrl: string | null;
  onDownload: () => void;
}

export function DocumentTabs({ 
  documentId, 
  title, 
  isLoadingPreview, 
  documentUrl, 
  onDownload 
}: DocumentTabsProps) {
  return (
    <Tabs defaultValue="preview" className="w-full">
      <TabsList className="mb-4">
        <TabsTrigger value="preview">Preview</TabsTrigger>
        <TabsTrigger value="comments">
          Comments <MessageSquare className="ml-1 h-3 w-3" />
        </TabsTrigger>
        <TabsTrigger value="history">
          History <History className="ml-1 h-3 w-3" />
        </TabsTrigger>
      </TabsList>
      <TabsContent value="preview">
        <DocumentPreview 
          isLoadingPreview={isLoadingPreview} 
          documentUrl={documentUrl} 
          title={title} 
          onDownload={onDownload} 
        />
      </TabsContent>
      <TabsContent value="comments">
        <Card className="border-0 shadow-none h-[600px]">
          <ScrollArea className="h-full pr-4">
            <CommentsPanel documentId={documentId} />
          </ScrollArea>
        </Card>
      </TabsContent>
      <TabsContent value="history">
        <Card className="border-0 shadow-none h-[600px]">
          <ScrollArea className="h-full pr-4">
            <DocumentStatusHistory documentId={documentId} />
          </ScrollArea>
        </Card>
      </TabsContent>
    </Tabs>
  );
}
